// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PoseTiles_wrapper___j7Ge"};